export class AiException extends Error {
  readonly meta?: Record<string, unknown>;

  constructor(message: string, meta: Record<string, unknown> = {}) {
    super(message);

    Object.setPrototypeOf(this, AiException.prototype);

    this.name = AiException.name;
    this.message = message;
    this.meta = meta;
  }
}
